
import Table from './Table'
// import TableMobileSort from '../../../../../node_modules/@oruga-ui/oruga-next/src/components/table/TableMobileSort'

Vue.component(Table.name, Table)
// Vue.component(TableMobileSort.name, TableMobileSort)